module.exports = __webpack_public_path__ + "static/img/honor-banner.cbc47e76.jpg";